import { partition } from 'es-toolkit';
import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Grid, Stack, Typography } from '@mui/material';

import { hasSupervisorFeatureFlag } from '@paragon/login-tools';
import { naturalSortByProperty } from '@paragon/utilities';

import { showCreateTruckDriverDialog } from '../../actions/dialogActions';
import { RootState } from '../../store';
import { useAppDispatch, useAppSelector } from '../hooks';
import { TruckDriverCard } from '../interface/cards/TruckDrivererCard';
import { ResponsiveButtonBar } from '../interface/ResponsiveButtonBar';

export function TruckDriversPage() {
  const dispatch = useAppDispatch();
  const isSupervisor = useAppSelector(hasSupervisorFeatureFlag);
  const truckDriversState = useAppSelector((state: RootState) => state.truckDrivers);

  if (truckDriversState.status === 'loading' || truckDriversState.status === 'catastrophicallyFailed') return null;

  // Archived truck drivers will appear at the end of the list
  const [truckDrivers, archivedTruckDrivers] = partition(
    Object.values(truckDriversState.truckDrivers),
    (truckDriver) => !truckDriver.archived,
  );
  const orderedTruckDriversList = naturalSortByProperty(truckDrivers, (truckDriver) => truckDriver.name).concat(
    naturalSortByProperty(archivedTruckDrivers, (archivedTruckDriver) => archivedTruckDriver.name),
  );

  return (
    <Stack>
      <Stack direction="row" sx={{ alignItems: 'center' }}>
        <Typography variant="h3" gutterBottom sx={{ marginRight: 'auto' }}>
          Truck Drivers
        </Typography>

        {isSupervisor && (
          <ResponsiveButtonBar
            breakpoint="sm"
            icon={<AddIcon />}
            actions={[['Create Truck Driver', () => void dispatch(showCreateTruckDriverDialog())]]}
          />
        )}
      </Stack>

      <Grid container spacing={1} sx={{ alignItems: 'stretch' }}>
        {orderedTruckDriversList.map((truckDriver) => (
          <Grid key={truckDriver.guid} size={{ xs: 12, md: 6 }}>
            <TruckDriverCard truckDriver={truckDriver} />
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}
